import { apiSlice } from '../../api-slice';

export const typeApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createType: builder.mutation({
            query: (data) => ({
                url: 'types',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Type'],
            // async onQueryStarted(
            //   _arg,
            //   { queryFulfilled: _query, dispatch: _dispatch },
            // ) {},
        }),

        getTypes: builder.query({
            query: (params) => ({
                url: `types`,
                method: 'GET',
                params,
            }),
            providesTags: ['Type'],
            keepUnusedDataFor: 600,
        }),

        deleteType: builder.mutation({
            query: (id) => ({
                url: `types/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Type'],
        }),

        editType: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `types/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Type'],
        }),
    }),
});

export const {
    useCreateTypeMutation,
    useGetTypesQuery,
    useDeleteTypeMutation,
    useEditTypeMutation,
} = typeApi;
